

<div
  class="page-wrapper chiller-theme toggled"
  [ngStyle]="commonservice.showTour"
>
  <main class="page-content">
    <div class="bgColor">
      <!-- <div class="container"> -->
     <div class="row header-row">
  <div class="col-md-6">
    <p class="appTitle">
      SMSCAP
    </p>
  </div>
  <div class="col-md-6">
    <p class="adminName">
      {{ adminName }}
      <img
        src="assets/tenant-avatar.jpg"
        alt="Admin Avatar"
        class="rounded-circle"
      />
    </p>
  </div>
</div>


      <!-- <div class="row my-4">
        <div class="col">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-3 dashCol">
                <div>
                  <img
                    class="collegeImg"
                    src="../../../assets/side-menu/college.png"
                  />
                  <p>{{ totalColg }}</p>
                </div>
                <h6 class="card-title">Total Colleges</h6>
              </div>

              <div class="col-md-3 dashCol" style="background: #fd6084">
                <div class="collegeDiv">
                  <img
                    class="collegeImg"
                    src="../../../assets/side-menu/course-dash.png"
                  />
                  <p>{{ totalCourse }}</p>
                </div>
                <h6 class="card-title">Total Courses</h6>
              </div>

              <div class="col-md-3 dashCol" style="background: #fbbd4b">
                <div class="collegeDiv">
                  <img
                    class="collegeImg"
                    src="../../../assets/side-menu/student.png"
                  />
                  <p>{{ totalStudents }}</p>
                </div>
                <h6 class="card-title">Total Students</h6>
              </div>
              <div class="col-md-3 dashCol" style="background: #ba40f9">
                <div class="collegeDiv">
                  <img
                    class="collegeImg"
                    src="../../../assets/side-menu/trending-courses.png"
                  />
                  <p>{{ trendingCourse }}</p>
                </div>
                <h6 class="card-title">Trending Courses</h6>
              </div>

              <div class="col-md-3 dashCol" style="background: #65c76c">
                <div class="collegeDiv">
                  <img
                    class="collegeImg"
                    src="../../../assets/side-menu/foreign-university.png"
                  />
                  <p>{{ abroardUniver }}</p>
                </div>
                <h6 class="card-title">Abroad University</h6>
              </div>
            </div>
          </div>
        </div>
      </div> -->
<!-- Responsive cards grid -->
<div class="cards-wrapper my-4">
  <div class="cards-grid" role="list" aria-label="Dashboard statistics">
    <div class="stat-card" role="listitem" aria-label="Total colleges">
      <div class="stat-media">
        <img src="../../../assets/side-menu/college.png" alt="" aria-hidden="true" />
      </div>
      <div class="stat-body">
        <div class="stat-number">{{ totalColg }}</div>
        <div class="stat-title">Total Colleges</div>
      </div>
    </div>

    <div class="stat-card" role="listitem" aria-label="Total courses" style="--card-bg: #fd6084;">
      <div class="stat-media">
        <img src="../../../assets/side-menu/course-dash.png" alt="" aria-hidden="true" />
      </div>
      <div class="stat-body">
        <div class="stat-number">{{ totalCourse }}</div>
        <div class="stat-title">Total Courses</div>
      </div>
    </div>

    <div class="stat-card" role="listitem" aria-label="Total students" style="--card-bg: #fbbd4b;">
      <div class="stat-media">
        <img src="../../../assets/side-menu/student.png" alt="" aria-hidden="true" />
      </div>
      <div class="stat-body">
        <div class="stat-number">{{ totalStudents }}</div>
        <div class="stat-title">Total Students</div>
      </div>
    </div>

    <div class="stat-card" role="listitem" aria-label="Trending courses" style="--card-bg: #ba40f9;">
      <div class="stat-media">
        <img src="../../../assets/side-menu/trending-courses.png" alt="" aria-hidden="true" />
      </div>
      <div class="stat-body">
        <div class="stat-number">{{ trendingCourse }}</div>
        <div class="stat-title">Trending Courses</div>
      </div>
    </div>

    <div class="stat-card" role="listitem" aria-label="Abroad university" style="--card-bg: #65c76c;">
      <div class="stat-media">
        <img src="../../../assets/side-menu/foreign-university.png" alt="" aria-hidden="true" />
      </div>
      <div class="stat-body">
        <div class="stat-number">{{ abroardUniver }}</div>
        <div class="stat-title">Abroad University</div>
      </div>
    </div>
  </div>
</div>

   <!-- <div class="row my-4 searchDiv">
     -->
    <div class="row my-4 searchDiv flex-nowrap align-items-center">

  <div class="col">
    <div class="container-fluid">
      <div class="row d-flex align-items-center">
        
  

  

        <div class="col-auto searchCol">
          <button
            type="button"
            class="btn btn-primary addCourseBtn"
            (click)="openAdd()"
          >
            <i class="fa fa-plus" aria-hidden="true"></i>Add Students
          </button>
        </div>

      </div>
    </div>
  </div>
</div>


      <!-- <div class="tableView" *ngIf="showData">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>S.NO</th>
                <th>User Name</th>
                <th>Date of Joining</th>
                <th>Phone Number</th>
                <th>Email Address</th>
                <th>Father's Name</th>
                <th>Date of Birth</th>
                <th>District</th>
                <th>Referral code</th>
                <th>Reffered code</th>
                <th>Status</th>
                <th>Permission</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let student of allStudents; let i = index">
                <td>{{ i + 1 }}</td>
                <td>
                  <img
                    width="30px"
                    height="30px"
                    [src]="'assets/tenant-avatar.jpg'"
                    class="rounded-circle"
                  />
                  {{ student.user_name }}
                </td>
                <td>{{ student.date }}</td>
                <td>{{ student.phone_num }}</td>
                <td>{{ student.email_id }}</td>
                <td>{{ student.father_name }}</td>
                <td>{{ student.dateOfBirth }}</td>
                <td>{{ student.district }}</td>
                <td>{{ student.referal_code }}</td>
                <td>{{ student.referred_code }}</td>
                <td>
                  <button
                    class="btn btn-sm btn-danger"
                    *ngIf="student.user_status == 1"
                    (click)="userActive(student, 0)"
                  >
                    In active
                  </button>
                  <button
                    class="btn btn-sm btn-success"
                    *ngIf="student.user_status == 0"
                    (click)="userActive(student, 1)"
                  >
                    Active
                  </button>
                </td>

                <td>
                  <label class="switch">
                    <input
                      type="checkbox"
                      [(ngModel)]="student.isAllow"
                      (change)="userPermission(student, student.isAllow)"
                    />
                    <span class="slider"></span>
                  </label>
                </td>

                <td>
                  <i
                    class="fa fa-pencil iconEdit"
                    aria-hidden="true"
                    (click)="editStudent(student)"
                  ></i>
                  <i
                    class="fa fa-eye iconEdit"
                    aria-hidden="true"
                    (click)="viewStudent(student)"
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> -->
<div class="ag-theme-alpine" style="width: 100%; height: 500px;">
  <div class="d-flex justify-content-between align-items-center mb-2">
  <div>
    Show 
    <select class="form-select d-inline-block w-auto"
            (change)="onPageSizeChanged($event)">
      <option [value]="20" selected>20</option>
      <option [value]="30">30</option>
      <option [value]="50">50</option>
      <option [value]="100">100</option>
    </select>
    entries
  </div>
</div>
<div class="search-container">
  <div class="search-box">
    <i class="fa fa-search"></i>
    <input
      type="text"
      placeholder="Search by Name, Phone, Email..."
      [(ngModel)]="searchText"
      (input)="onFilterChanged()"
    />
  </div>
</div>
<!-- <ag-grid-angular
  class="ag-theme-alpine custom-grid"
  [rowData]="allStudents"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  [pagination]="true"
  [paginationPageSize]="paginationPageSize"
  (gridReady)="onGridReady($event)"
  domLayout="autoHeight"
>
</ag-grid-angular> -->
<ag-grid-angular
  class="ag-theme-alpine custom-grid"
  [rowData]="allStudents"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  [pagination]="true"
  [paginationPageSize]="paginationPageSize"
  (gridReady)="onGridReady($event)"
  domLayout="autoHeight"

 
  [enableCellTextSelection]="true"
  [suppressCopySingleCellRanges]="false"
  [suppressClipboardPaste]="true"
>
</ag-grid-angular>

</div>

      <div class="noData" *ngIf="showNodata">
        <h2>Currenly No Data Available!</h2>
      </div>
    </div>

    <div class="backdrop" [ngStyle]="{ display: display }"></div>
    <div
      class="modal"
      id="successModel"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: display }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header" *ngIf="showAdd">
            Add Students
            <button
              type="button"
              class="close"
              aria-label="Close"
              (click)="onCloseHandled()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-header" *ngIf="showEdit">
            Edit Students
            <button
              type="button"
              class="close"
              aria-label="Close"
              (click)="onCloseHandled()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="dltmodal-content animate modal-body dltBl">
            <form [formGroup]="studentForm">
              <div style="text-align: center">
                <img
                  width="80px"
                  height="80px"
                  *ngIf="imageUrl"
                  [src]="imageUrl"
                  class="rounded-circle"
                />
                <label class="rounded-circle imgLabel">
                  <i class="fa fa-camera" aria-hidden="true"></i>
                  <input
                    type="file"
                    formControlName="studentImg"
                    (change)="handleFileInput($event.target.files)"
                    hidden
                  />
                </label>
              </div>
              <div class="error-messages">
                <div *ngFor="let error of error_messages.studentImg">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm.get('studentImg').hasError(error.type) &&
                      (studentForm.get('studentImg').dirty ||
                        studentForm.get('studentImg').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label>User Role</label>
                <select
                  class="form-control"
                  formControlName="userRoleVal"
                  [(ngModel)]="userRole"
                >
                  <option
                    *ngFor="let users of userRoleData; let x = index"
                    [ngValue]="users.id"
                  >
                    {{ users.roles }}
                  </option>
                </select>
              </div>
              <div class="error-messages">
                <div *ngFor="let error of error_messages.userRoleVal">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm.get('userRoleVal').hasError(error.type) &&
                      (studentForm.get('userRoleVal').dirty ||
                        studentForm.get('userRoleVal').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <label>Student Name</label>
              <input
                type="text"
                class="form-control"
                formControlName="studentNameVal"
                [(ngModel)]="studentName"
              />
              <div class="error-messages">
                <div *ngFor="let error of error_messages.studentNameVal">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm.get('studentNameVal').hasError(error.type) &&
                      (studentForm.get('studentNameVal').dirty ||
                        studentForm.get('studentNameVal').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <label>Whatsapp Number</label>
              <input
                type="text"
                class="form-control"
                formControlName="phoneno"
                [(ngModel)]="phonenumber"
                maxlength="10"
                minlength="10"
              />
              <div class="error-messages">
                <div *ngFor="let error of error_messages.phoneno">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm.get('phoneno').hasError(error.type) &&
                      (studentForm.get('phoneno').dirty ||
                        studentForm.get('phoneno').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <label>Email Address</label>
              <input
                type="email"
                class="form-control"
                formControlName="email"
                [(ngModel)]="emailAddress"
              />
              <div class="error-messages">
                <div *ngFor="let error of error_messages.email">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm.get('email').hasError(error.type) &&
                      (studentForm.get('email').dirty ||
                        studentForm.get('email').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label>First Graduate</label>
                <select
                  class="form-control"
                  formControlName="firstGraduateVal"
                  [(ngModel)]="firstGraduate"
                >
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              </div>

              <div class="form-group">
                <label>Quota</label>
                <select
                  class="form-control"
                  formControlName="quotaVal"
                  [(ngModel)]="quota"
                >
                  <option value="Management">Management</option>
                  <option value="Councelling">Councelling</option>
                  <option value="Both">Both</option>
                </select>
              </div>

              <div class="form-group">
                <label>Community</label>
                <select
                  class="form-control"
                  formControlName="communityVal"
                  [(ngModel)]="community"
                >
                  <option value="OC">OC</option>
                  <option value="BC">BC</option>
                  <option value="MBC">MBC</option>
                  <option value="SC">SC</option>
                  <option value="ST">ST</option>
                  <option value="SCA">SCA</option>
                  <option value="BC Converted Christian">
                    BC Converted Christian
                  </option>
                  <option value="Others">Others</option>
                </select>
              </div>

              <label>Choice of Course</label>
              <input
                type="text"
                class="form-control"
                formControlName="choiceOfCourseVal"
                [(ngModel)]="choiceOfCourse"
              />
              <div class="error-messages">
                <div *ngFor="let error of error_messages.choiceOfCourseVal">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm
                        .get('choiceOfCourseVal')
                        .hasError(error.type) &&
                      (studentForm.get('choiceOfCourseVal').dirty ||
                        studentForm.get('choiceOfCourseVal').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <label>Choice of College</label>
              <input
                type="text"
                class="form-control"
                formControlName="choiceOfCollegeVal"
                [(ngModel)]="choiceOfCollege"
              />
              <div class="error-messages">
                <div *ngFor="let error of error_messages.choiceOfCollegeVal">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm
                        .get('choiceOfCollegeVal')
                        .hasError(error.type) &&
                      (studentForm.get('choiceOfCollegeVal').dirty ||
                        studentForm.get('choiceOfCollegeVal').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <!-- <label>Educational Qualification</label>
                            <input type="text" class="form-control" formControlName="qualificationVal" [(ngModel)]="qualification">
                            <div class="error-messages">
                                <div *ngFor="let error of error_messages.qualificationVal">
                                    <div class="error-message" *ngIf="studentForm.get('qualificationVal').hasError(error.type) && (studentForm.get('qualificationVal').dirty || studentForm.get('qualificationVal').touched)">
                                        {{ error.message }}
                                    </div>
                                </div>
                            </div> -->

              <div class="form-group">
                <label>Educational Qualification</label>
                <select
                  class="form-control"
                  formControlName="qualificationVal"
                  [(ngModel)]="qualification"
                >
                  <option value="10th Standard">10th Standard</option>
                  <option value="12th Standard">12th Standard</option>
                  <option value="Under Graduate">Under Graduate</option>
                  <option value="Podt Graduate">Post Graduate</option>
                  <option value="Diplamo">Diplamo</option>
                  <option value="Others">Others</option>
                </select>
              </div>

              <label>School or college name</label>
              <input
                type="text"
                class="form-control"
                formControlName="colgVal"
                [(ngModel)]="clgName"
              />
              <div class="error-messages">
                <div *ngFor="let error of error_messages.colgVal">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm.get('colgVal').hasError(error.type) &&
                      (studentForm.get('colgVal').dirty ||
                        studentForm.get('colgVal').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <label>Father Name</label>
              <input
                type="text"
                class="form-control"
                formControlName="fatherNameVal"
                [(ngModel)]="fatherName"
              />
              <div class="error-messages">
                <div *ngFor="let error of error_messages.fatherNameVal">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm.get('fatherNameVal').hasError(error.type) &&
                      (studentForm.get('fatherNameVal').dirty ||
                        studentForm.get('fatherNameVal').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <label>Father Mobile Number</label>
              <input
                type="text"
                maxlength="10"
                minlength="10"
                class="form-control"
                formControlName="fatherMobileVal"
                [(ngModel)]="fatherMobile"
              />
              <div class="error-messages">
                <div *ngFor="let error of error_messages.fatherMobileVal">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm.get('fatherMobileVal').hasError(error.type) &&
                      (studentForm.get('fatherMobileVal').dirty ||
                        studentForm.get('fatherMobileVal').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <label>Place</label>
              <input
                type="text"
                class="form-control"
                formControlName="placeVal"
                [(ngModel)]="place"
              />
              <div class="error-messages">
                <div *ngFor="let error of error_messages.placeVal">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm.get('placeVal').hasError(error.type) &&
                      (studentForm.get('placeVal').dirty ||
                        studentForm.get('placeVal').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <label>District</label>
              <input
                type="text"
                class="form-control"
                formControlName="districtVal"
                [(ngModel)]="district"
              />
              <div class="error-messages">
                <div *ngFor="let error of error_messages.districtVal">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm.get('districtVal').hasError(error.type) &&
                      (studentForm.get('districtVal').dirty ||
                        studentForm.get('districtVal').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <label>Date of Birth</label>
              <input
                class="form-control"
                [(ngModel)]="dob"
                type="date"
                formControlName="dobVal"
              />
              <div class="error-messages">
                <div *ngFor="let error of error_messages.dobVal">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm.get('dobVal').hasError(error.type) &&
                      (studentForm.get('dobVal').dirty ||
                        studentForm.get('dobVal').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label>Select Course</label>
                <select
                  class="form-control"
                  formControlName="preferredCourseVal"
                  [(ngModel)]="preferredCourse"
                >
                  <option
                    *ngFor="
                      let prefered_course of preferedCourseData;
                      let x = index
                    "
                    [ngValue]="prefered_course.type"
                  >
                    {{ prefered_course.type }}
                  </option>
                </select>
              </div>
              <div class="error-messages">
                <div *ngFor="let error of error_messages.preferredCourseVal">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm
                        .get('preferredCourseVal')
                        .hasError(error.type) &&
                      (studentForm.get('preferredCourseVal').dirty ||
                        studentForm.get('preferredCourseVal').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>
              <!-- <div *ngIf="showAdd">
                                <label>Blood Group</label>
                                <input type="text" class="form-control" formControlName="bloodGroupVal" [(ngModel)]="bloodGroup">
                                <div class="error-messages">
                                    <div *ngFor="let error of error_messages.bloodGroupVal">
                                        <div class="error-message" *ngIf="studentForm.get('bloodGroupVal').hasError(error.type) && (studentForm.get('bloodGroupVal').dirty || studentForm.get('bloodGroupVal').touched)">
                                            {{ error.message }}
                                        </div>
                                    </div>
                                </div>
                            </div> -->

              <label *ngIf="showAdd">Password</label>
              <input
                *ngIf="showAdd"
                type="password"
                formControlName="paswdVal"
                class="form-control"
                [(ngModel)]="password"
              />
              <div class="error-messages" *ngIf="showAdd">
                <div *ngFor="let error of error_messages.paswdVal">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm.get('paswdVal').hasError(error.type) &&
                      (studentForm.get('paswdVal').dirty ||
                        studentForm.get('paswdVal').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <label *ngIf="showEdit">Password</label>
              <input
                *ngIf="showEdit"
                disabled
                type="password"
                formControlName="paswdVal"
                class="form-control"
                [(ngModel)]="password"
              />
              <div class="error-messages" *ngIf="showEdit">
                <div *ngFor="let error of error_messages.paswdVal">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm.get('paswdVal').hasError(error.type) &&
                      (studentForm.get('paswdVal').dirty ||
                        studentForm.get('paswdVal').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <label *ngIf="showAdd">Confirm Password</label>
              <input
                *ngIf="showAdd"
                type="password"
                formControlName="confirmPass"
                class="form-control"
                [(ngModel)]="confirmPassword"
              />
              <div class="error-messages" *ngIf="showAdd">
                <div *ngFor="let error of error_messages.confirmPass">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm.get('confirmPass').hasError(error.type) &&
                      (studentForm.get('confirmPass').dirty ||
                        studentForm.get('confirmPass').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <label *ngIf="showEdit">Confirm Password</label>
              <input
                *ngIf="showEdit"
                disabled
                type="password"
                formControlName="confirmPass"
                class="form-control"
                [(ngModel)]="confirmPassword"
              />
              <div class="error-messages" *ngIf="showEdit">
                <div *ngFor="let error of error_messages.confirmPass">
                  <div
                    class="error-message"
                    *ngIf="
                      studentForm.get('confirmPass').hasError(error.type) &&
                      (studentForm.get('confirmPass').dirty ||
                        studentForm.get('confirmPass').touched)
                    "
                  >
                    {{ error.message }}
                  </div>
                </div>
              </div>

              <p
                *ngIf="showErr"
                class="error-messages"
                style="color: red; font-size: 0.7em"
              >
                Password and Confirm Passwords should be the same.
              </p>

              <div *ngIf="showAdd">
                <label>Referral Code</label>
                <input
                  type="text"
                  formControlName="referralVal"
                  class="form-control"
                  [(ngModel)]="referral"
                />
                <div class="error-messages">
                  <div *ngFor="let error of error_messages.referralVal">
                    <div
                      class="error-message"
                      *ngIf="
                        studentForm.get('referralVal').hasError(error.type) &&
                        (studentForm.get('referralVal').dirty ||
                          studentForm.get('referralVal').touched)
                      "
                    >
                      {{ error.message }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="addBtn" *ngIf="showAdd">
                <button class="commonBtn mt-2" (click)="addStudent()">
                  Add Student
                </button>
              </div>

              <div class="addBtn" *ngIf="showEdit">
                <button class="commonBtn mt-2" (click)="updateStudent()">
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
